// Our main Task Manager component - like the main room in our house
import { useState, useEffect } from 'react';
import './App.css';

function App() {
  // Think of useState like having a notebook where we write things down
  // tasks = what's currently written, setTasks = the pencil to update it
  const [tasks, setTasks] = useState([]);
  const [newTaskTitle, setNewTaskTitle] = useState('');

  // When our component first loads, get all tasks from our backend
  useEffect(() => {
    fetchTasks();
  }, []); // The [] means "do this once when component starts"

  // Function to get tasks from our backend server
  const fetchTasks = async () => {
    try {
      // Ask our backend for all tasks
      const response = await fetch('http://localhost:5000/api/tasks');
      const data = await response.json();
      
      if (data.success) {
        setTasks(data.tasks); // Update our notebook with the tasks
      }
    } catch (error) {
      console.log('Error fetching tasks:', error);
    }
  };

  // Function to add a new task
  const addTask = async () => {
    if (!newTaskTitle.trim()) return; // Don't add empty tasks
    
    try {
      // Send the new task to our backend
      const response = await fetch('http://localhost:5000/api/tasks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title: newTaskTitle }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        setTasks([...tasks, data.task]); // Add new task to our list
        setNewTaskTitle(''); // Clear the input box
      }
    } catch (error) {
      console.log('Error adding task:', error);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>📝 My Task Manager</h1>
        <p>A simple app to manage your daily tasks!</p>
        
        {/* Input section to add new tasks */}
        <div style={{ margin: '20px 0' }}>
          <input
            type="text"
            value={newTaskTitle}
            onChange={(e) => setNewTaskTitle(e.target.value)}
            placeholder="Enter a new task..."
            style={{
              padding: '10px',
              marginRight: '10px',
              borderRadius: '5px',
              border: '1px solid #ddd'
            }}
          />
          <button 
            onClick={addTask}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Add Task
          </button>
        </div>

        {/* Display all our tasks */}
        <div>
          <h2>Your Tasks ({tasks.length})</h2>
          {tasks.length === 0 ? (
            <p>No tasks yet. Add your first task above! 🚀</p>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {tasks.map((task) => (
                <li 
                  key={task.id}
                  style={{
                    backgroundColor: '#f8f9fa',
                    margin: '10px 0',
                    padding: '15px',
                    borderRadius: '5px',
                    color: '#333'
                  }}
                >
                  <span>{task.title}</span>
                  {task.completed && <span> ✅</span>}
                </li>
              ))}
            </ul>
          )}
        </div>
      </header>
    </div>
  );
}

export default App;